// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-box {
  --base-size: 24px;
  --loading-color: var(--white-color-lightest-transparent-85);
  width: var(--base-size);
  height: var(--base-size);
}
.loading-box .half-circle-spinner, .loading-box .half-circle-spinner * {
  box-sizing: border-box;
}
.loading-box .half-circle-spinner {
  width: var(--base-size);
  height: var(--base-size);
  border-radius: 100%;
  position: relative;
}
.loading-box .half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(var(--base-size) / 8) solid transparent;
}
.loading-box .half-circle-spinner .circle.circle-1 {
  border-top-color: var(--loading-color);
  animation: half-circle-spinner-animation 1s infinite;
}
.loading-box .half-circle-spinner .circle.circle-2 {
  border-bottom-color: var(--loading-color);
  animation: half-circle-spinner-animation 1s infinite alternate;
}
@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/LoadingBox.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,2DAAA;EACA,uBAAA;EACA,wBAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oDAAA;AADJ;AAIE;EACE,sCAAA;EACA,oDAAA;AAFJ;AAKE;EACE,yCAAA;EACA,8DAAA;AAHJ;AAME;EACE;IACE,uBAAA;EAJJ;EAME;IACE,yBAAA;EAJJ;AACF","sourcesContent":[".loading-box {\r\n  --base-size: 24px;\r\n  --loading-color: var(--white-color-lightest-transparent-85);\r\n  width: var(--base-size);\r\n  height: var(--base-size);\r\n\r\n  .half-circle-spinner, .half-circle-spinner * {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .half-circle-spinner {\r\n    width: var(--base-size);\r\n    height: var(--base-size);\r\n    border-radius: 100%;\r\n    position: relative;\r\n  }\r\n\r\n  .half-circle-spinner .circle {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 100%;\r\n    border: calc(var(--base-size) / 8) solid transparent;\r\n  }\r\n\r\n  .half-circle-spinner .circle.circle-1 {\r\n    border-top-color: var(--loading-color);\r\n    animation: half-circle-spinner-animation 1s infinite;\r\n  }\r\n\r\n  .half-circle-spinner .circle.circle-2 {\r\n    border-bottom-color: var(--loading-color);\r\n    animation: half-circle-spinner-animation 1s infinite alternate;\r\n  }\r\n\r\n  @keyframes half-circle-spinner-animation {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100%{\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
